import { defineMessages } from "react-intl";

export default defineMessages({
  "serviceRequest.postedBy": {
    id: "serviceRequest.postedBy",
    defaultMessage: "Posted By {clientName}",
  },
  "serviceRequest.serviceProviderType.option1": {
    id: "serviceRequest.serviceProviderType.option1",
    defaultMessage: "Individuals and self-employed",
  },
  "serviceRequest.serviceProviderType.option2": {
    id: "serviceRequest.serviceProviderType.option2",
    defaultMessage: "Self-employed only",
  },
  "serviceRequest.serviceAddress": {
    id: "serviceRequest.serviceAddress",
    defaultMessage: "Service address",
  },
  "serviceRequest.serviceProviderType": {
    id: "serviceRequest.serviceProviderType",
    defaultMessage: "Service provider type",
  },
  "serviceRequestStateType.posted": {
    id: "serviceRequest.state.posted",
    defaultMessage: "Task published",
  },
  "serviceRequest.cancellation.title": {
    id: "serviceRequest.cancellation.title",
    defaultMessage: "Confirm cancelation?",
  },
  "serviceRequest.cancellation.message": {
    id: "serviceRequest.cancellation.message",
    defaultMessage: "Your request will be permanently deleted.",
  },
  "serviceRequest.cancellation.confirmCTAText": {
    id: "serviceRequest.cancellation.confirmCTAText",
    defaultMessage: "Confirm cancellation",
  },
  "serviceRequest.cancellation.cancelCTAText": {
    id: "serviceRequest.cancellation.cancelCTAText",
    defaultMessage: "Cancel",
  },
  "serviceRequest.visitOfferDetail.serviceProvider": {
    id: "serviceOfferOrderPreview.spOffer",
    defaultMessage: "{serviceProviderName}'s offer",
  },
  "serviceRequest.visitOfferDetail.title": {
    id: "serviceRequest.visitOfferDetail.title",
    defaultMessage: "The work itself",
  },
  "serviceRequest.visitOfferDetail.description": {
    id: "serviceRequest.visitOfferDetail.description",
    defaultMessage:
      "The service will be assessed during the visit. You'll get a quote to accept or refuse.",
  },
  "serviceRequest.visitOfferDetail.status": {
    id: "serviceRequest.visitOfferDetail.status",
    defaultMessage: "To define",
  },
  "serviceRequest.offerDetail.visit": {
    id: "serviceRequest.offerDetail.visit",
    defaultMessage: "Visit",
  },
  "serviceRequest.offerDetail.forQuote": {
    id: "serviceRequest.offerDetail.forQuote",
    defaultMessage: "for quote",
  },

  /**
   *  billing unit
   *  "flat" | "hour" | "day" | "week"
   */
  hour: {
    id: "orderDescription.hourlyRate",
    defaultMessage: "Hourly rate",
  },
  day: {
    id: "serviceRequest.offerDetail.dailyRate",
    defaultMessage: "Daily rate",
  },
  week: {
    id: "serviceRequest.offerDetail.weeklyRate",
    defaultMessage: "Weekly rate",
  },
  flat: {
    id: "serviceOfferOrderPreview.fixedRate",
    defaultMessage: "Hourly rate",
  },
  "serviceRequest.offerDetail.freeVisit": {
    id: "serviceRequest.offerDetail.freeVisit",
    defaultMessage: "+ Free visit",
  },
  "serviceRequest.distance": {
    id: "serviceRequest.distance",
    defaultMessage: "Lives within {distance}",
  },
  "serviceRequest.selectServiceProviderOffer": {
    id: "serviceRequest.selectServiceProviderOffer",
    defaultMessage: "Select {serviceProviderName}",
  },
  "serviceRequest.decline": {
    id: "serviceRequest.decline",
    defaultMessage: "Decline",
  },
  "serviceRequest.discuss": {
    id: "serviceRequest.discuss",
    defaultMessage: "Discuss",
  },
  "serviceRequest.noOffer": {
    id: "serviceRequest.noOffer",
    defaultMessage: "No offer yet",
  },
  "serviceRequest.askAnOffer": {
    id: "serviceRequest.askAnOffer",
    defaultMessage: "Ask an offer",
  },
  "serviceRequest.offerAsked": {
    id: "serviceRequest.offerAsked",
    defaultMessage: "Offer asked",
  },
  "serviceRequest.offerWithdrawn": {
    id: "serviceRequest.offerWithdrawn",
    defaultMessage: "Offer withdrawn",
  },
  "serviceRequest.seeOffer": {
    id: "serviceRequest.seeOffer",
    defaultMessage: "See offer",
  },
  "serviceRequest.superTalentBadge.popoverDescription": {
    id: "serviceRequest.superTalentBadge.popoverDescription",
    defaultMessage: "SuperTalent badge: maximum reliability on Ring Twice",
  },
  "serviceRequest.superTalentBadge.popoverLinkCTA": {
    id: "serviceRequest.superTalentBadge.popoverLinkCTA",
    defaultMessage: "Find out more",
  },
  "serviceRequest.superTalentBadge.popoverLink": {
    id: "serviceRequest.superTalentBadge.popoverLink",
    defaultMessage: "https://ringtwice.be/",
  },
  "serviceRequest.categoryCarousel.title": {
    id: "serviceRequest.categoryCarousel.title",
    defaultMessage: "Did you know?",
  },
  "serviceRequest.categoryCarousel.description": {
    id: "serviceRequest.categoryCarousel.description",
    defaultMessage:
      "Ring Twice brings together thousands of service providers in over 120 different service categories.",
  },
  "serviceRequest.categoryCarousel.createServiceRequestCTA": {
    id: "serviceRequest.categoryCarousel.createServiceRequestCTA",
    defaultMessage: "Create another request",
  },
  "serviceRequest.declineOffer.title": {
    id: "serviceRequest.declineOffer.title",
    defaultMessage:
      "Why do you want to refuse {serviceProviderName}’s application?",
  },
  "serviceRequest.declineOffer.warningMessage": {
    id: "serviceRequest.declineOffer.warningMessage",
    defaultMessage:
      "It will prevent {serviceProviderName} from applying again for this task only.",
  },
  "serviceRequest.declineOffer.declineButton.text": {
    id: "serviceRequest.declineOffer.declineButton.text",
    defaultMessage: "Refuse this application",
  },
  "serviceRequest.declineOffer.cancelButton.text": {
    id: "photo-book.delete-cancel-button",
    defaultMessage: "Cancel",
  },
  "serviceRequest.declineOffer.reasons.not_enough_information": {
    id: "serviceRequest.declineOffer.reasons.not_enough_information",
    defaultMessage: "Le profil manque d'informations",
  },
  "serviceRequest.declineOffer.reasons.no_created_offer": {
    id: "serviceRequest.declineOffer.reasons.no_created_offer",
    defaultMessage:
      "Pas d'offre, m\u00eame si je montre de l'int\u00e9r\u00eat",
  },
  "serviceRequest.declineOffer.reasons.amount_too_high": {
    id: "serviceRequest.declineOffer.reasons.amount_too_high",
    defaultMessage: "Le montant de l'offre est trop \u00e9lev\u00e9",
  },
  "serviceRequest.declineOffer.reasons.missing_skills": {
    id: "serviceRequest.declineOffer.reasons.missing_skills",
    defaultMessage: "Pas assez qualifi\u00e9 pour ce job",
  },
  "serviceRequest.declineOffer.reasons.location_too_far": {
    id: "serviceRequest.declineOffer.reasons.location_too_far",
    defaultMessage: "La distance est trop grande",
  },
  "serviceRequest.declineOffer.reasons.no_availability": {
    id: "serviceRequest.declineOffer.reasons.no_availability",
    defaultMessage: "Les disponibilit\u00e9s ne correspondent pas",
  },
  "serviceRequest.declineOffer.reasons.unresponsive": {
    id: "serviceRequest.declineOffer.reasons.unresponsive",
    defaultMessage: "Pas de r\u00e9ponse \u00e0 mes questions",
  },
  "serviceRequest.declineOffer.reasons.other": {
    id: "serviceRequest.declineOffer.reasons.other",
    defaultMessage: "Autre raison",
  },
  "serviceRequest.declineOffer.tell_us_more_about_it": {
    id: "serviceRequest.declineOffer.tell_us_more_about_it",
    defaultMessage: "Tell us more about it",
  },
  "serviceRequest.declineOffer.successful_decline": {
    id: "serviceRequest.declineOffer.successful_decline",
    defaultMessage: "{serviceProviderName}'s application refused.",
  },
  "serviceRequest.declineOffer.error_while_declining": {
    id: "serviceRequest.declineOffer.error_while_declining",
    defaultMessage: "Error while declining {serviceProviderName}'s application",
  },
  seeDetails: {
    id: "seeDetails",
    defaultMessage: "See details",
  },
  hideDetails: {
    id: "hideDetails",
    defaultMessage: "Hide details",
  },
  edit: {
    id: "edit",
    defaultMessage: "Edit",
  },
  seeProfile: {
    id: "seeProfile",
    defaultMessage: "See profile",
  },
  "serviceRequest.statusStep.1": {
    id: "serviceRequest.statusStep.1",
    defaultMessage: "Task published",
  },
  "serviceRequest.statusStep.1.description": {
    id: "serviceRequest.statusStep.1.description",
    defaultMessage: "Wait for service providers to apply to your request.",
  },
  "serviceRequest.statusStep.2": {
    id: "serviceRequest.statusStep.2",
    defaultMessage: "Assign a service provider",
  },
  "serviceRequest.statusStep.2.description": {
    id: "serviceRequest.statusStep.2.description",
    defaultMessage: "Review the offers and pick your favorite.",
  },
  "serviceRequest.statusStep.3": {
    id: "serviceRequest.statusStep.3",
    defaultMessage: "Service completion",
  },
  "serviceRequest.statusStep.3.description": {
    id: "serviceRequest.statusStep.3.description",
    defaultMessage:
      "The service provider completes the job, as agreed with you.",
  },
  "serviceRequest.statusStep.4": {
    id: "serviceRequest.statusStep.4",
    defaultMessage: "Payment online",
  },
  "serviceRequest.statusStep.4.description": {
    id: "serviceRequest.statusStep.4.description",
    defaultMessage: "Pay securely online once the job is done.",
  },
  "serviceRequest.statusStep.cardTitle": {
    id: "serviceRequest.statusStep.cardTitle",
    defaultMessage: "And now?",
  },
  "serviceRequest.statusStep.whatAreTheNextSteps": {
    id: "serviceRequest.statusStep.whatAreTheNextSteps",
    defaultMessage: "What are the next steps to my request?",
  },
  "serviceRequest.candidates.header": {
    id: "serviceRequest.candidates.header",
    defaultMessage: "Candidates",
  },
  "serviceRequest.candidates.filter.option1": {
    id: "serviceRequest.candidates.filter.option1",
    defaultMessage: "Recommended for this service",
  },
  "serviceRequest.candidates.filter.option1.description": {
    id: "serviceRequest.candidates.filter.option1.description",
    defaultMessage:
      "This ranking is based on the reviews of other clients, the number of services performed and cancelled, client loyalty and the potential of new service providers!",
  },
  "serviceRequest.candidates.filter.option2": {
    id: "serviceRequest.candidates.filter.option2",
    defaultMessage: "Last activities",
  },
  filterBy: {
    id: "filterBy",
    defaultMessage: "Filter by",
  },
  lastUpdated: {
    id: "lastUpdated",
    defaultMessage: "Last updated",
  },
  recommended: {
    id: "recommended",
    defaultMessage: "Recommended",
  },
  "serviceRequest.candidates.emptyPlaceholder": {
    id: "serviceRequest.candidates.emptyPlaceholder",
    defaultMessage:
      "Hang tight! Your request has been sent to service providers nearby. The first offers usually arrive <bold>within 2 hours</bold>. We’ll <bold>notify you by email</bold> as soon as someone shows interest.",
  },
  goToMyDemands: {
    id: "goToMyDemands",
    defaultMessage: "Go to my demands",
  },
  "s_cat.similarRequestCount": {
    id: "s_cat.similarRequestCount",
    defaultMessage: "{count} job{isPlural} in",
  },
  "s_cat.electrician": {
    id: "s_cat.electrician",
    defaultMessage: "\u00c9l\u00e9ctricit\u00e9",
  },
  "s_cat.painter": {
    id: "s_cat.painter",
    defaultMessage: "Peinture",
  },
  "s_cat.carpenter": {
    id: "s_cat.carpenter",
    defaultMessage: "Menuiserie",
  },

  "s_cat.plumber": {
    id: "s_cat.plumber",
    defaultMessage: "Plomberie",
  },
  "s_cat.appliance_repair": {
    id: "s_cat.appliance_repair",
    defaultMessage: "R\u00e9paration d'\u00e9lectrom\u00e9nager",
  },
  "s_cat.handyman": {
    id: "s_cat.handyman",
    defaultMessage: "Petits travaux",
  },
  "s_cat.petsitter_care": {
    id: "s_cat.petsitter_care",
    defaultMessage: "Pension animali\u00e8re",
  },
  "s_cat.home_care": {
    id: "s_cat.home_care",
    defaultMessage: "Garde chez le propri\u00e9taire",
  },
  "s_cat.dog_walking": {
    id: "s_cat.dog_walking",
    defaultMessage: "Promenade de chien",
  },
  "s_cat.dog_grooming": {
    id: "s_cat.dog_grooming",
    defaultMessage: "Toilettage de chien",
  },
  "s_cat.home_visit": {
    id: "s_cat.home_visit",
    defaultMessage: "Visite d'animaux \u00e0 domicile",
  },
  "s_cat.cooking": {
    id: "s_cat.cooking",
    defaultMessage: "Chef \u00e0 domicile",
  },
  "s_cat.sewing": {
    id: "s_cat.sewing",
    defaultMessage: "Couture",
  },
  "s_cat.cleaning": {
    id: "s_cat.cleaning",
    defaultMessage: "Nettoyage",
  },
  "s_cat.ironing": {
    id: "s_cat.ironing",
    defaultMessage: "Repassage",
  },
  "s_cat.moving": {
    id: "s_cat.moving",
    defaultMessage: "D\u00e9m\u00e9nagement",
  },
  "s_cat.bulky_items": {
    id: "s_cat.bulky_items",
    defaultMessage: "Enl\u00e8vement d'encombrants",
  },
  "s_cat.delivery": {
    id: "s_cat.delivery",
    defaultMessage: "Livraison",
  },
  "s_cat.gardener": {
    id: "s_cat.gardener",
    defaultMessage: "Jardinage",
  },
  "s_cat.heavy_gardening": {
    id: "s_cat.heavy_gardening",
    defaultMessage: "Gros travaux de jardinage",
  },
  "s_cat.language_lessons": {
    id: "s_cat.language_lessons",
    defaultMessage: "Cours de langues",
  },
  "s_cat.music_lessons": {
    id: "s_cat.music_lessons",
    defaultMessage: "Cours de musique",
  },
  "s_cat.sports_lessons": {
    id: "s_cat.sports_lessons",
    defaultMessage: "Cours de sport",
  },

  "s_cat.cooking_lessons": {
    id: "s_cat.cooking_lessons",
    defaultMessage: "Cours de cuisine",
  },
  "s_cat.private_lessons": {
    id: "s_cat.private_lessons",
    defaultMessage: "Cours particuliers",
  },
  "s_cat.writer_translator": {
    id: "s_cat.writer_translator",
    defaultMessage: "R\u00e9daction et traduction",
  },
  "s_cat.photographer": {
    id: "s_cat.photographer",
    defaultMessage: "Photographie",
  },
  "s_cat.magician": {
    id: "s_cat.magician",
    defaultMessage: "Magie",
  },
  "s_cat.musician": {
    id: "s_cat.musician",
    defaultMessage: "Animation musicale",
  },
  "s_cat.dj": {
    id: "s_cat.dj",
    defaultMessage: "DJ",
  },
  "s_cat.clown": {
    id: "s_cat.clown",
    defaultMessage: "Clown",
  },
  "s_cat.caterer": {
    id: "s_cat.caterer",
    defaultMessage: "Traiteur",
  },
  "s_cat.assistance_training": {
    id: "s_cat.assistance_training",
    defaultMessage: "Assistance et formation",
  },
  "s_cat.repair_troubleshooting": {
    id: "s_cat.repair_troubleshooting",
    defaultMessage: "R\u00e9paration et d\u00e9pannage",
  },
  "s_cat.creation": {
    id: "s_cat.creation",
    defaultMessage: "Conception visuelle",
  },
  "s_cat.occasional_care": {
    id: "s_cat.occasional_care",
    defaultMessage: "Garde ponctuelle",
  },
  "s_cat.recurrent_care": {
    id: "s_cat.recurrent_care",
    defaultMessage: "Garde r\u00e9guli\u00e8re",
  },
  "s_cat.beauty": {
    id: "s_cat.beauty",
    defaultMessage: "Soins de beaut\u00e9",
  },
  "s_cat.relaxation": {
    id: "s_cat.relaxation",
    defaultMessage: "Bien-\u00eatre et relaxation",
  },
  "s_cat.senior_help": {
    id: "s_cat.senior_help",
    defaultMessage: "Aide \u00e0 la personne",
  },
  "s_cat.locksmith": {
    id: "s_cat.locksmith",
    defaultMessage: "Serrurerie",
  },
  "s_cat.bike_repair": {
    id: "s_cat.bike_repair",
    defaultMessage: "R\u00e9paration de v\u00e9lo",
  },
  "category.title.1": { id: "category.title.1", defaultMessage: "Bricolage" },
  "category.body.1": {
    id: "category.body.1",
    defaultMessage:
      "Petits travaux, peinture, \u00e9lectricit\u00e9, plomberie, r\u00e9parations...",
  },
  "category.title.2": { id: "category.title.2", defaultMessage: "Jardinage" },
  "category.body.2": {
    id: "category.body.2",
    defaultMessage:
      "Tonte, taille de haie, entretien, nettoyage de goutti\u00e8res...",
  },
  "category.title.3": { id: "category.title.3", defaultMessage: "Transport" },
  "category.body.3": {
    id: "category.body.3",
    defaultMessage:
      "D\u00e9m\u00e9nagement, enl\u00e8vement des encombrants, livraison...",
  },
  "category.title.4": { id: "category.title.4", defaultMessage: "Animaux" },
  "category.body.4": {
    id: "category.body.4",
    defaultMessage:
      "Garde d\u2019animaux, visite \u00e0 domicile, promenade de chien...",
  },
  "category.title.5": {
    id: "category.title.5",
    defaultMessage: "Aide m\u00e9nag\u00e8re",
  },
  "category.body.5": {
    id: "category.body.5",
    defaultMessage: "Nettoyage, repassage, cuisine, couture...",
  },
  "category.title.6": {
    id: "category.title.6",
    defaultMessage: "Informatique",
  },
  "category.body.6": {
    id: "category.body.6",
    defaultMessage: "R\u00e9paration, d\u00e9pannage, formation, assistance...",
  },
  "category.title.7": {
    id: "category.title.7",
    defaultMessage: "Baby sitting",
  },
  "category.body.7": {
    id: "category.body.7",
    defaultMessage: "Garde ponctuelle, garde r\u00e9currente...",
  },
  "category.title.8": {
    id: "category.title.8",
    defaultMessage: "Cours & Assistance",
  },
  "category.body.8": {
    id: "category.body.8",
    defaultMessage:
      "Cours particuliers, cours de langues, r\u00e9daction et traduction...",
  },
  "category.title.9": {
    id: "category.title.9",
    defaultMessage: "Ev\u00e8nements",
  },
  "category.body.9": {
    id: "category.body.9",
    defaultMessage: "Photographe, traiteur, serveur, musicien...",
  },
  "category.title.10": {
    id: "category.title.10",
    defaultMessage: "Soins & bien-\u00eatre",
  },
  "category.body.10": {
    id: "category.body.10",
    defaultMessage: "Massage, coiffure, aide seniors...",
  },
  newTalent: {
    id: "newTalent",
    defaultMessage: "New talent",
  },
});
